module.exports = __webpack_public_path__ + "assets/img/faspay_718.1cd9b80c.png";